import { render } from "./ticheng-list.vue?vue&type=template&id=095cd949&scoped=true"
import script from "./ticheng-list.vue?vue&type=script&lang=js"
export * from "./ticheng-list.vue?vue&type=script&lang=js"

import "./ticheng-list.vue?vue&type=style&index=0&id=095cd949&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095cd949"]])

export default __exports__